module.exports = __webpack_public_path__ + "img/title-bg.2fe6717e.png";